module.exports = __webpack_public_path__ + "static/media/snp-logo.5d1880a3.png";